<template>
  <div :class="['lee-gesture-password',thetype]" ref="gesture"
       :style="{width:width+'px',height:height+'px','--successcolor':successcolor,'--errorcolor':errorcolor}">
    <div style="position: absolute;top:-20px;left: 50%;"></div>
    <div class="grid" v-for="item in 9" :key="item">
      <div class="dot" ref="dot"><i></i></div>
    </div>
    <canvas id="path"></canvas>
  </div>
</template>
<script>
export default {
    name: 'LeeGesturePassword',
    inheritAttrs: false,
    data() {
        return {
            thetype: '',
            left: 0,
            top: 0,
            isDown: false,
            pos: [],
            tempass: [],//记录零时密码
            ctx: null,
            dotw: 0//DOT的大小的，这个下面需要数据依赖
        }
    },
    watch: {
        type: {
            immediate: true,
            handler(value) {
                let types = ['square', 'circle', 'leaf']
                let fi = types.filter(function (el) {
                    return el.indexOf(value) > -1;
                })
                if (fi.length < 1) {
                    this.thetype = "circle"
                } else {
                    this.thetype = value
                }
            }
        }
    },
    mounted() {
        let canvas = document.getElementById('path')
        this.ctx = canvas.getContext('2d');
        let dot = this.$refs.dot
        this.dotw = dot[0].offsetWidth
        canvas.width = this.width
        canvas.height = this.height
        let tips = document.createElement('div')
        tips.className = 'tips'
        this.isDown = false;
        dot.forEach((el, xh) => {
            this.pos.push({xh: xh + 1, x: el.offsetLeft, y: el.offsetTop})
        })

        this.chuli()
        window.addEventListener('resize', (e) => {
            this.chuli()
        })
    },
    methods: {
        chuli() {
            let gesture = this.$refs.gesture
            if (gesture) {
                let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
                let scrollLeft = document.documentElement.scrollLeft || document.body.scrollLeft
                this.left = gesture.getBoundingClientRect().left + scrollLeft;
                this.top = gesture.getBoundingClientRect().top + scrollTop;
                //动作开始
                gesture.addEventListener('mousedown', () => {
                    event.preventDefault()
                    this.isDown = true
                    this.markDot(event.pageX, event.pageY)
                    this.drawPath(event.pageX, event.pageY)
                })
                gesture.addEventListener('mousemove', () => {
                    event.preventDefault()
                    if (this.isDown) {
                        this.markDot(event.pageX, event.pageY)
                        this.drawPath(event.pageX, event.pageY)
                    }
                })
                gesture.addEventListener('mouseup', () => {
                    this.check()
                })
                gesture.addEventListener('mouseleave', () => {
                    if (this.isDown) {
                        this.check()
                    }
                })
                gesture.addEventListener('touchstart', (event) => {
                    event.preventDefault()
                    event.stopPropagation()
                    this.isDown = true
                    this.markDot(event.targetTouches[0].pageX, event.targetTouches[0].pageY)
                    this.drawPath(event.targetTouches[0].pageX, event.targetTouches[0].pageY)
                })
                gesture.addEventListener('touchmove', (event) => {
                    event.preventDefault()
                    event.stopPropagation()
                    if (this.isDown) {
                        this.markDot(event.targetTouches[0].pageX, event.targetTouches[0].pageY)
                        this.drawPath(event.targetTouches[0].pageX, event.targetTouches[0].pageY)
                    }
                })
                gesture.addEventListener('touchend', (event) => {
                    event.stopPropagation()
                    this.check()
                })
            }
        },
        check() {
            let dot = this.$refs.dot
            let gesture = this.$refs.gesture
            let tips = document.createElement('div')
            tips.className = 'tips'
            this.isDown = false
            let msg = ''
            if (JSON.stringify(this.password) != JSON.stringify(this.tempass)) {
                gesture.classList.add('error')
                tips.innerText = '密码错误'
                msg = 'err'
                this.drawErr()
            } else {
                gesture.classList.remove('error')
                tips.innerText = '验证成功'
                msg = 'success'
            }
            this.$emit('check', msg)
            this.tempass = []
            gesture.appendChild(tips)
            setTimeout(() => tips.style.opacity = 1, 1)
            setTimeout(() => {
                tips.style.opacity = 0
                setTimeout(() => tips.remove(), 500)
                this.ctx.clearRect(0, 0, this.width, this.height)
                dot.forEach((el) => {
                    el.children[0].style.cssText = ''

                })
                gesture.classList.remove('error')
            }, 1500)

        },
        markDot(x, y) {
            let newX = x - this.left
            let newY = y - this.top
            let fi = this.pos.filter((el) => {
                return newX - el.x <= this.dotw && newX - el.x >= 0 && newY - el.y <= this.dotw && newY - el.y >= 0
            })
            let dot = this.$refs.dot
            if (fi.length > 0) {
                dot[fi[0].xh - 1].querySelector('i').style.opacity = '1'
                if (this.tempass.indexOf(fi[0].xh) < 0) {
                    this.tempass.push(fi[0].xh)
                }
            }
        },
        drawPath(x, y) {
            this.ctx.clearRect(0, 0, this.width, this.height)
            let newX = x - this.left
            let newY = y - this.top
            this.ctx.lineWidth = this.pathwidth;
            this.ctx.lineCap = 'round'
            this.ctx.lineJoin = 'round'
            this.ctx.strokeStyle = this.successcolor;
            this.ctx.beginPath();
            for (let i = 0; i < this.tempass.length; i++) {
                this.ctx.lineTo(this.pos[this.tempass[i] - 1].x + this.dotw / 2, this.pos[this.tempass[i] - 1].y + this.dotw / 2);
            }
            if (this.tempass.length > 0) {
                this.ctx.lineTo(newX, newY);
            }
            this.ctx.stroke();
            this.ctx.closePath();
        },
        drawErr() {
            this.ctx.clearRect(0, 0, this.width, this.height)
            this.ctx.strokeStyle = this.errorcolor;
            this.ctx.beginPath();
            for (let i = 0; i < this.tempass.length; i++) {
                this.ctx.lineTo(this.pos[this.tempass[i] - 1].x + this.dotw / 2, this.pos[this.tempass[i] - 1].y + this.dotw / 2);
            }
            this.ctx.stroke();
            this.ctx.closePath();
        }
    },
    props: {
        type: {
            type: String,
            default: 'circle'
        },
        width: {
            type: Number,
            default: 350
        },
        height: {
            type: Number,
            default: 350
        },
        password: {
            type: Array,
            default() {
                return []
            }
        },
        successcolor: {
            type: String,
            default: '#67c23a'
        },
        errorcolor: {
            type: String,
            default: '#f56c6c'
        },
        pathwidth: {
            type: Number,
            default: 8
        }
    }
};
</script>
<style>
.lee-gesture-password {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  color: var(--successcolor);
  position: relative;
}

.lee-gesture-password canvas {
  position: absolute;
  z-index: 1;
}


.lee-gesture-password .tips {
  position: absolute;
  left: 50%;
  top: 50%;
  background: rgba(0, 0, 0, .8);
  width: 90px;
  height: 90px;
  border-radius: 8px;
  transform: translate(-50%, -50%);
  transition: all .5s;
  opacity: 0;
  text-align: center;
  line-height: 90px;
  color: #fff;
  font-size: 16px;
  z-index: 44;
}

.lee-gesture-password .grid {
  width: 33.33%;
  height: 33.33%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.lee-gesture-password .dot {
  width: 70%;
  height: 70%;
  border-radius: 100%;
  border: solid 1px currentColor;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
}

.lee-gesture-password.square .dot {
  border-radius: 0;
}

.lee-gesture-password.leaf .dot {
  border-radius: 50% 0% 50% 0%/50% 0% 50% 0%;
}

.lee-gesture-password .dot i {
  width: 30%;
  height: 30%;
  background: currentColor;
  border-radius: 100%;
  transition: all .2s;
  opacity: 0;
}

.lee-gesture-password.square .dot i {
  border-radius: 0;
}

.lee-gesture-password.error {
  color: var(--errorcolor);
  animation: shake .15s
}


@keyframes shake {
  0% {
    transform: translateX(0);
  }

  25% {
    transform: translateX(-20px);
  }

  50% {
    transform: translateX(0);
  }

  75% {
    transform: translateX(20px);
  }

  100% {
    transform: translateX(0);
  }
}
</style>



// WEBPACK FOOTER //
// node_modules/leevueplugin/src/LeeGesturePassword.vue